// extracted by mini-css-extract-plugin
export default {"empty":"dataTypeSelectorTable_empty__7L7gN"};